package fyi.moko.hotpl.data.network

import fyi.moko.hotpl.domain.model.Friendship
import fyi.moko.hotpl.domain.model.FriendSharedPlace
import fyi.moko.hotpl.domain.model.InviteCode
import fyi.moko.hotpl.domain.model.PlaceStatus
import kotlinx.serialization.Serializable

// Wire DTOs for the Phase 3 social collections. Field sets must stay in lockstep with the
// hasOnly whitelists in firestore.rules.prod (isValidInviteCodePayload / the friendships
// create rule) — an extra field here means every push is denied.

@Serializable
data class InviteCodeDto(
    val ownerUid: String,
    val ownerName: String,
    @Serializable(with = FirestoreLong::class)
    val createdAt: Long,
)

@Serializable
data class FriendshipDto(
    val uids: List<String>,
    val names: Map<String, String>,
    val inviteCode: String,
    @Serializable(with = FirestoreLong::class)
    val createdAt: Long,
)

fun InviteCode.toDto(): InviteCodeDto = InviteCodeDto(
    ownerUid = ownerUid,
    ownerName = ownerName,
    createdAt = createdAt,
)

fun InviteCodeDto.toDomain(code: String): InviteCode = InviteCode(
    code = code,
    ownerUid = ownerUid,
    ownerName = ownerName,
    createdAt = createdAt,
)

fun Friendship.toDto(): FriendshipDto = FriendshipDto(
    uids = uids,
    names = names,
    inviteCode = inviteCode,
    createdAt = createdAt,
)

fun FriendshipDto.toDomain(docId: String): Friendship = Friendship(
    id = docId,
    uids = uids,
    names = names,
    inviteCode = inviteCode,
    createdAt = createdAt,
)

fun PublicPlaceDto.toFriendSharedPlace(): FriendSharedPlace = FriendSharedPlace(
    placeId = placeId,
    ownerId = ownerId,
    name = name,
    status = try { PlaceStatus.valueOf(status) } catch (e: Exception) { PlaceStatus.VISITED },
    liked = liked,
    latitude = latitude,
    longitude = longitude,
    tags = tags,
    updatedAt = updatedAt,
    photos = photos,
    phoneNumber = phoneNumber,
    website = website,
)
